import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg, fmtCard } from "@/lib/api";
import { Field } from "@/components/AuthLayout";
import { CardVisual } from "@/components/wallet/CardVisual";

export const SettingsAdmin = () => {
  const [card, setCard] = useState("");
  const [current, setCurrent] = useState("");
  const [pw, setPw] = useState({ current_password: "", new_password: "", confirm: "" });

  useEffect(() => { api.get("/wallet/info").then(({ data }) => setCurrent(data.deposit_card)); }, []);

  const saveCard = async (e) => {
    e.preventDefault();
    try {
      const { data } = await api.put("/admin/settings/deposit-card", { card });
      setCurrent(data.deposit_card); setCard(""); toast.success("Depozit kartı yeniləndi");
    } catch (err) { toast.error(errMsg(err)); }
  };

  const savePw = async (e) => {
    e.preventDefault();
    if (pw.new_password.length < 8) return toast.error("Parol minimum 8 simvol olmalıdır");
    if (pw.new_password !== pw.confirm) return toast.error("Parollar uyğun gəlmir");
    try {
      const { data } = await api.post("/auth/change-password", { current_password: pw.current_password, new_password: pw.new_password });
      localStorage.setItem("jp_token", data.token);
      setPw({ current_password: "", new_password: "", confirm: "" }); toast.success("Parol dəyişdirildi");
    } catch (err) { toast.error(errMsg(err)); }
  };

  return (
    <div className="grid lg:grid-cols-2 gap-6">
      <form noValidate onSubmit={saveCard} className="rounded-2xl border border-white/10 bg-[#111] p-6 space-y-5" data-testid="deposit-card-form">
        <h3 className="font-display font-bold">Depozit kartı</h3>
        {current && <CardVisual number={current} />}
        <Field label="Yeni kart nömrəsi" inputMode="numeric" value={card} onChange={(e) => setCard(fmtCard(e.target.value))} placeholder="0000 0000 0000 0000" data-testid="deposit-card-input" />
        <button className="btn-gold rounded-full px-8 py-3 font-display font-bold" data-testid="deposit-card-save-btn">Kartı yenilə</button>
      </form>
      <form noValidate onSubmit={savePw} className="rounded-2xl border border-white/10 bg-[#111] p-6 space-y-5 h-fit" data-testid="change-password-form">
        <h3 className="font-display font-bold">Admin parolunu dəyiş</h3>
        <Field label="Cari parol" type="password" value={pw.current_password} onChange={(e) => setPw({ ...pw, current_password: e.target.value })} data-testid="current-password-input" />
        <Field label="Yeni parol (min. 8)" type="password" value={pw.new_password} onChange={(e) => setPw({ ...pw, new_password: e.target.value })} data-testid="new-password-input" />
        <Field label="Yeni parolu təkrarla" type="password" value={pw.confirm} onChange={(e) => setPw({ ...pw, confirm: e.target.value })} data-testid="confirm-password-input" />
        <button className="btn-gold rounded-full px-8 py-3 font-display font-bold" data-testid="change-password-btn">Parolu dəyiş</button>
        <p className="text-xs text-zinc-500">Parolu unutsanız, giriş səhifəsində "Parolu unutmusunuz?" ilə email-ə kod alıb sıfırlaya bilərsiniz.</p>
      </form>
    </div>
  );
};
